export default "__VITE_ASSET__Bg_gm9Ek__"